import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { storeNameColumn } from 'TableCommon/defaultColumns'
import { getDifferenceWithPrecision, getNumberWithCurrency } from 'utils'

import Box from '@mui/material/Box'

const TitleIcons = storeNameColumn.RowRenderer

function TableMarginRow({ data, index, style }) {
  const { t: translate } = useTranslation()
  const { showModal, maxRevenue, stores } = data
  const store = stores[index]
  const modalHandler = () => showModal(store)
  const barWidth = Math.round((100 * store.revenueCurrent) / maxRevenue)

  return (
    <Box
      style={style}
      onClick={modalHandler}
      className={classNames('row cursor-pointer', { 'is-temporary-closed': store.temporaryClosed })}
    >
      <div className="row-wrapper flex-row">
        <div className="cell-bar" style={{ width: `${barWidth}%` }} />

        <div className="cell-title flex-row">
          <TitleIcons {...data} store={store} />
        </div>

        <div className="cell-category tablet-portrait-up-only">
          <span className={classNames('category', `is-${store.cluster === '-' ? 'none' : store.cluster.toLocaleLowerCase()}`)}>
            {store.cluster}
          </span>
        </div>

        <div className="cell cell-value">
          <span>
            {getNumberWithCurrency({
              currency: store.currency,
              number: store.revenueCurrent,
              precision: 0,
              translate,
            })}
          </span>
        </div>

        <div className="cell cell-margin">
          <div>
            {
              getDifferenceWithPrecision({
                number: store.marginCurrent,
                precision: 0,
                translate,
              }).value
            }
          </div>

          <div>
            {translate('revenue.ly')}:{' '}
            {
              getDifferenceWithPrecision({
                handleNullCase: true,
                number: store.marginCompared,
                precision: 0,
                suffix: '%',
                translate,
              }).value
            }
          </div>
        </div>

        <div className="cell cell-margin-value">
          {getNumberWithCurrency({
            currency: store.currency,
            number: store.marginValueCurrent,
            precision: 0,
            translate,
          })}
        </div>
      </div>
    </Box>
  )
}

TableMarginRow.propTypes = {
  data: PropTypes.shape({
    maxRevenue: PropTypes.number,
    showModal: PropTypes.func,
    stores: PropTypes.arrayOf(PropTypes.object),
  }),
  index: PropTypes.number,
  style: PropTypes.object,
}

export default TableMarginRow
